import { render } from "./Form.vue?vue&type=template&id=3fb55cb1&scoped=true&ts=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=3fb55cb1&scoped=true&lang=css"
import "./Form.vue?vue&type=style&index=1&id=3fb55cb1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb55cb1"]])

export default __exports__